module.exports = __webpack_public_path__ + "img/LC_Belgrade_white.a727134f.png";